export enum CustidStoreMode {
  cookie = 'cookie',
  session = 'session',
}
